const IS_DEVELOPMENT = false; // Change to true for local and false for production build

// Base URL configuration loaded from api-config.json
let configBaseUrl = null;

// Load config from api-config.json synchronously before endpoints are computed
const loadApiConfigSync = () => {
  try {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', '/api-config.json', false);
    xhr.send();
    
    if (xhr.status === 200 || xhr.status === 0) {
      const config = JSON.parse(xhr.responseText);
      configBaseUrl = config.baseUrl || null;
    }
  } catch (error) {
    // Default to relative paths if config doesn't exist or can't be loaded
    configBaseUrl = null;
  }
};

loadApiConfigSync();

// Get base URL with fallback to relative paths (default behavior)
const getBaseUrl = () => {
  // If config.baseUrl is null or empty, use fallback flow
  if (!configBaseUrl || configBaseUrl.trim() === '') {
    return IS_DEVELOPMENT ? '' : 'https://test.tribald.com';
  }
  
  // In development mode, extract only the path from the full URL
  // e.g., "https://test.tribald.com/pbp" becomes "/pbp"
  if (IS_DEVELOPMENT) {
    try {
      const url = new URL(configBaseUrl);
      return url.pathname;
    } catch (error) {
      // If not a valid URL, treat as path
      return configBaseUrl.startsWith('/') ? configBaseUrl : `/${configBaseUrl}`;
    }
  }
  
  // In production mode, return the full URL as is
  return configBaseUrl;
};

// Get folder path from URL segment (for fallback flow)
const getFolderPath = () => {
  const pathSegments = window.location.pathname.split('/');
  const portalSegment = pathSegments.filter(segment => segment)[0];
  return portalSegment || '';
};

// Build endpoint URLs
const buildEndpoint = (endpoint) => {
  const baseUrl = getBaseUrl();
  
  // If config.baseUrl was null or empty, use fallback flow with folder path
  if (!configBaseUrl || configBaseUrl.trim() === '') {
    const folderPath = getFolderPath();
    return `${baseUrl}/${folderPath}/api/${endpoint}`;
  }
  
  return `${baseUrl}/api/${endpoint}`;
};

// Endpoint definitions
const endpoints = {
  INS: 'ins.aspx',
  UTILS: 'utils.aspx',
  CCTHUTILS: 'ccthutils.aspx',
  PBPUTILS: 'pbputils.aspx',
  CRITUTILS: 'critutils.aspx'
};

// Export endpoints
export const INS = buildEndpoint(endpoints.INS);
export const UTILS = buildEndpoint(endpoints.UTILS);
export const CCTHUTILS = buildEndpoint(endpoints.CCTHUTILS);
export const PBPUTILS = buildEndpoint(endpoints.PBPUTILS);
export const CRITUTILS = buildEndpoint(endpoints.CRITUTILS);

// Export getter functions for dynamic endpoint resolution
export const getINS = () => buildEndpoint(endpoints.INS);
export const getUTILS = () => buildEndpoint(endpoints.UTILS);
export const getCCTHUTILS = () => buildEndpoint(endpoints.CCTHUTILS);
export const getPBPUTILS = () => buildEndpoint(endpoints.PBPUTILS);
export const getCRITUTILS = () => buildEndpoint(endpoints.CRITUTILS);

// Refresh config (useful if config is updated after initial load)
export const refreshConfig = async () => {
  try {
    const response = await fetch('/api-config.json');
    if (response.ok) {
      const config = await response.json();
      configBaseUrl = config.baseUrl || null;
    }
  } catch (error) {
    configBaseUrl = null;
  }
};
